import { type RootState } from '../../stores/redux';

export const getNotifications = (state: RootState) => state.notifications.queue;
